import React from 'react';
import UIContext from '../UIContext';

export default function UIProvider(props) {
  const { children } = props;
  return <UIContext.Provider>{children}</UIContext.Provider>;
}
